import { render } from "./BlFormFieldVoice.vue?vue&type=template&id=fb61ebe2&scoped=true"
import script from "./BlFormFieldVoice.vue?vue&type=script&lang=js"
export * from "./BlFormFieldVoice.vue?vue&type=script&lang=js"

import "./BlFormFieldVoice.vue?vue&type=style&index=0&id=fb61ebe2&scoped=true&lang=scss"

import exportComponent from "/tmp/b45e941b-d1ac-4235-8dba-072c0c886010/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb61ebe2"]])

export default __exports__